/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import type { GridConfig } from '@coursera-web/cds-labs';

import { ProductCard, breakpoints, useMediaQuery } from '@coursera/cds-core';

import { ShowMoreGridSectionPlaceholder } from 'bundles/cds-labs/components/ShowMoreGridSection/ShowMoreGridSectionPlaceholder';
import { CARD_LIST_BREAKPOINTS_CONFIG } from 'bundles/cds-labs/components/ShowMoreGridSection/constants';

type Props = {
  hideTitle?: boolean;
  hideButton?: boolean;
  itemsGridConfig?: GridConfig;
  defaultRows?: number;
  defaultMobileRows?: number;
  shouldShowListView?: boolean;
};

const styles = {
  cardWrapper: css`
    height: 100%;

    > * {
      height: inherit;
    }

    .cds-ProductCard-list {
      border: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    }
  `,
};

const ProductCardsPlaceholder = ({ defaultRows = 1, defaultMobileRows = 2, shouldShowListView, ...props }: Props) => {
  const isMobile = useMediaQuery(breakpoints.down('xs'));
  const isTablet = useMediaQuery(breakpoints.down('sm'));
  const shouldUseListVariant = shouldShowListView ?? (isTablet || isMobile);
  let itemsGridConfig = props.itemsGridConfig;

  if (!itemsGridConfig && shouldUseListVariant) {
    itemsGridConfig = CARD_LIST_BREAKPOINTS_CONFIG;
  }

  return (
    <ShowMoreGridSectionPlaceholder
      {...props}
      className="rc-ProductCardsPlaceholder"
      itemsGridConfig={itemsGridConfig}
      defaultRows={isMobile ? defaultMobileRows : defaultRows}
      renderPlaceholderItem={() => (
        <div css={styles.cardWrapper} data-testid="card-wrapper">
          <ProductCard variant={shouldUseListVariant ? 'list' : 'grid'} productType=" " loading={true} />
        </div>
      )}
    />
  );
};

export default ProductCardsPlaceholder;
